export const breakpoints = {
  lg: '992px',
  md: '768px',
  sm: '576px',
  xl: '1200px',
  xxl: '1440px',
} as const;

export type BreakpointNames = 'lg' | 'md' | 'sm' | 'xl' | 'xxl';
